module.exports = __webpack_public_path__ + "img/logo-luxtag.8e75dd44.svg";